"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArianeeHttpClient = void 0;
var axios_1 = __importDefault(require("axios"));
var tsyringe_1 = require("tsyringe");
var ArianeeHttpClient = /** @class */ (function () {
    function ArianeeHttpClient() {
        var _this = this;
        this.httpFetch = function (url, config) { return (0, axios_1.default)(url, config).then(function (result) { return result.data; }); };
        this.setRequestInterceptor = function (interceptor) {
            _this.httpRequestInterceptor = interceptor;
            return _this;
        };
        this.setHttpFetch = function (httpFetch) {
            _this.httpFetch = httpFetch;
            return _this;
        };
        this.RPCConfigurationFactory = function (endpoint, method, params) {
            return {
                method: 'POST',
                data: {
                    jsonrpc: '2.0',
                    method: method,
                    params: params,
                    id: ArianeeHttpClient_1.createKeyFromURL(endpoint, params)
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            };
        };
        this.RPCCall = function (endpoint, method, params) { return __awaiter(_this, void 0, void 0, function () {
            var config, RPCRes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = this.RPCConfigurationFactory(endpoint, method, params);
                        return [4 /*yield*/, this.fetch(endpoint, config)];
                    case 1:
                        RPCRes = _a.sent();
                        if (RPCRes.error) {
                            throw new Error(JSON.stringify(RPCRes.error));
                        }
                        if (RPCRes.result) {
                            RPCRes.result = (typeof (RPCRes.result) === 'string') ? JSON.parse(RPCRes.result) : RPCRes.result;
                        }
                        return [2 /*return*/, RPCRes];
                }
            });
        }); };
        /**
           * The exact same method as static fetch method
           */
    }
    ArianeeHttpClient_1 = ArianeeHttpClient;
    Object.defineProperty(ArianeeHttpClient, "defaultConfig", {
        /**
         * Default headers for fetch
         */
        get: function () {
            return {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    /**
     * HTTP call
     * Default configuration of headers is method GET and content-type: application/json
     * @param url
     * @param config
     * @return Promise{any}
     */
    ArianeeHttpClient.prototype.fetch = function (url, config) {
        if (config === void 0) { config = __assign({}, ArianeeHttpClient_1.defaultConfig); }
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (config.body) {
                            config.data = config.body;
                        }
                        if (!this.httpRequestInterceptor) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.httpRequestInterceptor(url, config)];
                    case 1:
                        result = _a.sent();
                        url = result.url;
                        config = result.config;
                        _a.label = 2;
                    case 2:
                        try {
                            return [2 /*return*/, this.httpFetch(url, config)];
                        }
                        catch (e) {
                            console.warn('Error on fetch', url, config);
                            Promise.reject(e);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    var ArianeeHttpClient_1;
    /**
     * Calculate hash key from url and headers of a request
     * @param url
     * @param config
     * @return {string}
     */
    ArianeeHttpClient.createKeyFromURL = function (url, config) {
        var hash = function (s) {
            var a = 1;
            var c = 0;
            var h;
            var o;
            if (s) {
                a = 0;
                for (h = s.length - 1; h >= 0; h--) {
                    o = s.charCodeAt(h);
                    a = ((a << 6) & 268435455) + o + (o << 14);
                    c = a & 266338304;
                    a = c !== 0 ? a ^ (c >> 21) : a;
                }
            }
            return String(a);
        };
        return hash(JSON.stringify(url) + JSON.stringify(config));
    };
    ArianeeHttpClient = ArianeeHttpClient_1 = __decorate([
        (0, tsyringe_1.injectable)()
    ], ArianeeHttpClient);
    return ArianeeHttpClient;
}());
exports.ArianeeHttpClient = ArianeeHttpClient;
//# sourceMappingURL=arianeeHttpClient.js.map